<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.sistema"
        ref="RkmDataTable"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                v-if="authorize('cadastro-sistema-update')"
                :to="{name: 'cadastro-sistema-edit', params: {id: item.sistema_id}}"
                color="primary"
                small
                title="Editar"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <!--<rkm-button
                v-if="authorize('cadastro-sistema-destroy')"
                @click="handleDestroy(item)"
                color="danger"
                small
                title="Excluir"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="trash" />
            </rkm-button>-->
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {authorization, error, notification} from '@/mixins'

// Others.
import unmask from '@/utils/unmask'

export default {
    computed: {
        fields() {
            return [
                {key: 'empresa_nome', label: 'Empresa', name: 'cadastro_empresa.nome', searchable: true, sortable: true},
                {key: 'ramo_atividade_nome', label: 'Ramo de atividade', name: 'cadastro_ramo_atividade.nome', searchable: true, sortable: true},
                {key: 'sistema_nome', label: 'Nome', name: 'cadastro_sistema.nome', searchable: true, sortable: true},
                {key: 'sistema_versao', label: 'Versão', name: 'cadastro_sistema.versao', searchable: true, sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações',},
            ]
        },
    },
    data: () => ({
        others: {unmask},
    }),
    inject: ['repositories'],
    methods: {
        handleDestroy(item) {
            const destroy = () => this.repositories.cadastro.sistema.destroy(item.sistema_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDangerConfirmation('Confirmação', `Deseja realmente excluir o sistema ${item.sistema_nome}?`, destroy, null, this.handleError)
        },
    },
    mixins: [authorization, error, notification],
}
</script>